module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Your Title tag :","metaDescription":"Your Meta-description tag :"},"fr":{"title":"Votre balise Title :","metaDescription":"Votre balise Meta description :"},"de":{"title":"Ihr Title-Tag :","metaDescription":"Ihr Meta-Beschreibung Tag :"}}')
  delete Component.options._Ctor
}
